import React, { useEffect, useRef, useState } from 'react';
import Loader from '../../common/Loader';
import MatchBet from '../../common/MatchBet';
import MessageInfo from '../../common/MessageInfo';
import MainContext from '../../contexts/MainContext';
import { useFetchMatch } from '../../data/fetchMatch';
import { getMatchIdOrStageId, getPrincipaleOPrimoGruppo } from '../../data/utils';
import { isWidgetEnabled, WidgetContext } from '../../data/widgets/WidgetContext';
import { getLabel } from '../../data/labels';
import LiveMatchBetGroup from '../common/LiveMatchBetGroup';
import MultiLiveMatchHeader from './MultiLiveMatchHeader';
import StatsToggle from '../../common/StatsToggle';

function MultiLiveMatch(props) {
    const mainContext = React.useContext(MainContext);
    const widgetContext = React.useContext(WidgetContext);
     /* Incorporo il match in uno stato, puo' essere modificato solo con chiamata a setMatchToFetch */
    const [matchToFetch] = useState(props.match);
    const [aggregataToFecth, setAggregataToFetch] = useState(getPrincipaleOPrimoGruppo(props.match.gruppiScommessa).idAggregata);
    const [aggregata, setAggregata] = useState(aggregataToFecth);
    const [state, dispatch, isSetInterval] = useFetchMatch(matchToFetch, aggregataToFecth, true, false); /* useState su props.match mi permette di evitare che questa chiamata parta 
                                                                                                    ad ogni rendering dei componenti padre */
    //const match = state.data;
    const [match, setMatch] = useState(props.match);

    useEffect(function() {
        if (!state.isLoading && !state.isError) {
            setAggregata(aggregataToFecth);
            setMatch(state.data)
        }
    }, [state, aggregataToFecth]);
    
    const betGroupsList = match?.gruppiScommessa?.map(function(betGroup, i) {
        return (
            <LiveMatchBetGroup key={i} active={betGroup.idAggregata === aggregata} idAggregata={betGroup.idAggregata} desc={betGroup.descrizione} changeAggregata={changeAggregata} />
        );
    });

    const betsList = match?.bets?.map(function(bet,index) {
        if (!bet.hasOdds) {
            return null;
        }
        return (
            <MatchBet betDescAlreadyCalc={true} key={bet.uniqueId || index} {...bet} expanded={true} />
        );
    });
    
    const widgetEnabled = isWidgetEnabled(props.match.sportRef,props.match.widgetType,props.match.geniusId,props.match.lsportWidgetId);
    const parts = props.match.score.combinedScore.split(' - ');
    const team1Score = parts[0];
    const team2Score = parts[1];

    function changeAggregata(ag) {
        if (ag !== aggregataToFecth) {
            setAggregataToFetch(ag);
            //setShowLoader(false);
            dispatch({ type: 'FETCH_INIT' });
            quoteCollapsed.current.classList.remove('collapsed');
        }
    }

    function removeMatch() {
        props.removeMatch(props.match.uniqueId);
    }

    function handleOpenMatch(){
        if(typeof props.openMatch==='function'){
            props.openMatch(props.match.sportRef,props.match.categoryRef,props.match.tournamentRef,props.match.id);
        }
           
    }

    function openWidget() {
        if (!widgetEnabled) {
            return;
        }

        widgetContext.setWidget({
            currentSection: mainContext.currentSection.current,
            widgetGeniusId: props.match.geniusId,
            widgetLsportId: props.match.lsportWidgetId,
            widgetProviderType: props.match.widgetType,
            widgetSportId: props.match.sportRef,
            widgetShowSidebar: false,
            widgetStartCollapsed: false,
            widgetS5Layout: '#1',
            widgetMatchId: getMatchIdOrStageId(props.match),
            widgetContainerId: "#collassaWidgetMultiLive-"+props.match.uniqueId
        });
    }

    const quoteCollapsed = useRef(null);
    function toggleCollapseQuote() {
        quoteCollapsed.current.classList.toggle('collapsed');
        quoteCollapsed.current.closest('.box-multilive').querySelectorAll('.quote-evento-multilive .quote-extra-partita').forEach(el => {
            const children = el.children;
            if (quoteCollapsed.current.classList.contains('collapsed')) {
                children[0].classList.add('collapsed');
                children[1].classList.remove('show');
            } else {
                children[0].classList.remove('collapsed');
                children[1].classList.add('show');
            }
        });
    }
    
    return (
        <div className="box-multilive">
            <div className="titolo-evento-multilive d-flex flex-row w-100">
                <MultiLiveMatchHeader {...props.match} team1Score={team1Score} team2Score={team2Score} />
                <div className="toolbox-multilive d-grid colonne-2 justify-content-center align-items-center">
                    <StatsToggle className="fas fa-chart-bar stat-sel pointer" match={props.match} />
                    <i className="fas fa-times pointer" onClick={removeMatch}></i>
                    <i className="fas fa-info-circle"></i>
                    <i className="fas fa-external-link-alt apri-trascinabile" onClick={openWidget} ></i>
                    <i className="fas fa-chevron-down" id="comprimi-eventi-multilive" ref={quoteCollapsed} onClick={toggleCollapseQuote} ></i>
                    <i className="fas fa-chevron-right" onClick={handleOpenMatch} ></i>
                </div>
                <div id="trascinabile" className="d-none flex-column justify-content-around align-items-center">
                    <div id="trascinabileheader" className="d-flex justify-content-between align-items-center bg-colore-1 bianco">
                        <div className="left"><i className="fas fa-hand-pointer"></i> {getLabel('live_page.multilive_draggable_widget_title')}</div>
                        <div className="right"><i className="fas fa-times pointer chiudiTrascinabile"></i></div>
                    </div>
                    <div className="trascinabileBody bg-nero p-3" id={"collassaWidgetMultiLive-"+props.match.uniqueId}>
                        {/*TODO gestire apertura widget multipli
                            flashbetWidgetUrl ?
                                <FlashbetWidget url={flashbetWidgetUrl}/>
                            :
                            isBetgeniusWidget?
                                <BetGeniusWidget url={getBetgeniustWidgetUrl(match.sportRef)} />
                            :
                            isStatsCoreWidget?
                                <StatsCoreWidget />
                            :
                            <></>
                        */
                        }
                    </div>
                </div>
            </div>
            {
            	(state.isLoading && !isSetInterval) || state.isError? 
            	<Loader error={state.isError} /> 
            	:        			
            	(
        			<div className="body-evento-multilive">
                        {(state.data && Object.keys(state.data).length===0) || state.data==null?
                        <MessageInfo message={getLabel('general.evento') + ' ' + getLabel('general.chiuso')} />
                        :
                        state.data.giocabilita!=undefined && !state.data.giocabilita?
                        <MessageInfo message={getLabel('general.giocabilita_chiusa')} />
                        :
                        <>
                            <div className="macro-gruppi d-si margine-giu">
                                <div className="aggregate">
                                    { betGroupsList }
                                </div>
                            </div>
                            <div className="quote-evento-multilive">
                                { betsList }
                            </div>
                        </>
                        }
	                </div>
            	)
            }
        </div>
    );
}

export default MultiLiveMatch;